import type { ComponentType } from 'react';

import { memo } from 'react';
import styled from 'styled-components';

import type { IconProps } from '~/components/shared/core/icons';
import { toKebabCase } from '~/utilities/parsers';

const S = {
  Icon: styled.li`
    list-style: none;
    width: 45px;
    height: 34px;
    padding: 0 ${({ theme }) => theme.size['1']};
    padding-bottom: ${({ theme }) => theme.size['1']};
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    color: ${({ theme }) => theme.colors.slate['400']};
    border-bottom: ${({ theme }) => theme.size['1']} solid currentColor;

    &[data-selected='true'] {
      color: ${({ theme }) => theme.colors.content['brand-accent']};
      border-bottom: ${({ theme }) => theme.size['1']} solid currentColor;
    }

    /* stylelint-disable-next-line a11y/no-outline-none */
    &:focus:not(:focus-visible) {
      outline: none;
    }
  `,
};

interface Props {
  CareIcon: ComponentType<IconProps>;
  isSelected: boolean;
  hasProductAccordions?: boolean;
  index: number;
  label?: string | null;
  mouseEnter: (arg0: number) => void;
  mouseLeave: () => void;
}

export const WashingCareIcon = memo(
  ({ CareIcon, isSelected, hasProductAccordions, index, label, mouseEnter, mouseLeave }: Props) => (
    <S.Icon
      aria-labelledby={`washing-label-${index}-${toKebabCase(label || '')}`}
      data-testid="washing-icon"
      data-selected={isSelected}
      tabIndex={0}
      onMouseEnter={() => mouseEnter(index)}
      onFocus={() => mouseEnter(index)}
      onBlur={mouseLeave}
      {...(!hasProductAccordions && { onMouseLeave: mouseLeave })}
    >
      <CareIcon color="currentColor" />
    </S.Icon>
  )
);

WashingCareIcon.displayName = 'WashingCareIconItem';
